export default {
  FETCH_SEARCH_SUGGESTION: 'FETCH_SEARCH_SUGGESTION',
  FETCH_TRENDING_SEARCHES: 'FETCH_TRENDING_SEARCHES',
  UPDATE_SEARCH_FIELD: 'UPDATE_SEARCH_FIELD',
  RESET_SEARCH: 'search/reset',
  SHOW_SCREEN: 'search/show_screen',
};
